// extracted by mini-css-extract-plugin
module.exports = {"svgIconWrapper":"SVGIcon_svgIconWrapper__RvzXl"};